import Vue from 'vue';

import VueRouter from 'vue-router';



import Home from '@/views/Home.vue';

import Performance from '@/views/Performance.vue';

import PerformanceDetail from '@/views/PerformanceDetail.vue';

import News from '@/views/News.vue';

import NewsDetail from '@/views/NewsDetail.vue';

import ServiceCenter from '@/views/ServiceCenter.vue';
import { SITE_INTRO, SITE_KEYWORDS } from '@/constants/portal';
import { updateSeo } from '@/utils/seo';



Vue.use(VueRouter);



const routes = [

  {

    path: '/',

    name: 'Home',

    component: Home,

    meta: {
      title: '首页',
      description: SITE_INTRO,
      keywords: SITE_KEYWORDS
    }

  },

  {

    path: '/performance',

    name: 'Performance',

    component: Performance,

    meta: {
      title: '演艺介绍',
      description: '长恨歌、驼铃传奇、千古情三大王牌演艺介绍，丝路欢乐世界与西安精品一日游线路。',
      keywords: '西安演艺,长恨歌,驼铃传奇,千古情,丝路欢乐世界,演出介绍'
    }

  },

  {

    path: '/performance/:id',

    name: 'PerformanceDetail',

    component: PerformanceDetail,

    meta: { title: '演艺详情', skipSeo: true }

  },

  {

    path: '/news',

    name: 'News',

    component: News,

    meta: {
      title: '新闻资讯',
      description: '百年票票平台动态、演出公告、线路信息与西安出行提示。',
      keywords: '西安旅游资讯,演出公告,出行提示,百年票票新闻'
    }

  },

  {

    path: '/news/:id',

    name: 'NewsDetail',

    component: NewsDetail,

    meta: { title: '资讯详情', skipSeo: true }

  },

  {

    path: '/service',

    name: 'ServiceCenter',

    component: ServiceCenter,

    meta: {
      title: '服务中心',
      description: '百年票票官方购票入口、企业微信客服与联系电话，为您提供全方位西安文旅出行服务。',
      keywords: '官方购票,企业微信客服,联系电话,百年票票服务中心'
    }

  },

  {

    path: '*',

    redirect: '/'

  }

];



const router = new VueRouter({

  mode: 'history',

  routes,

  scrollBehavior(to) {

    if (to.hash) {

      return { selector: to.hash, behavior: 'smooth' };

    }

    return { x: 0, y: 0 };

  }

});



router.afterEach(to => {
  if (to.meta && to.meta.skipSeo) return;
  updateSeo({
    title: to.meta && to.meta.title,
    description: to.meta && to.meta.description,
    keywords: to.meta && to.meta.keywords,
    url: typeof window !== 'undefined' ? window.location.href : ''
  });
});



export default router;

